<br />
<mat-expansion-panel class="margen-expansion" expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6 class="titulo-solicitud">Informe De Recorrido Vendedor</h6>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="contenedor-form">
    <form
      [formGroup]="ventasGroup"
      (ngSubmit)="busqueda()"
      class="example-form"
    >
      <div class="row">
        <div class="col s12 m6 l2">
          <span *ngIf="loadingAgencias">
            <mat-spinner
              [diameter]="30"
              style="margin: 0 auto; top: 15px"
            ></mat-spinner>
          </span>
          <span *ngIf="!loadingAgencias">
            <mat-form-field>
              <mat-label>AGENCIA</mat-label>
              <mat-select
                formControlName="idAgencia"
                (change)="cargarUsuariosAgencia()"
              >
                <mat-option
                  *ngFor="let agencia of agencias"
                  [value]="agencia.id"
                >
                  {{ agencia.valor }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
        </div>
        <div class="col s12 m6 l4">
          <span *ngIf="loadingUsuarios">
            <mat-spinner
              [diameter]="30"
              style="margin: 0 auto; top: 15px"
            ></mat-spinner>
          </span>
          <span *ngIf="!loadingUsuarios">
            <mat-form-field class="example-full-width">
              <input
                matInput
                placeholder="VENDEDOR"
                [matAutocomplete]="auto"
                formControlName="usuarioCtrl"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayFn"
              >
                <mat-option
                  *ngFor="let usuario of filteredUsuarios | async"
                  [value]="usuario"
                >
                  <span>{{ usuario.valor }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </span>
        </div>
        <div class="col s12 m6 l2">
          <mat-form-field>
            <input
              formControlName="fechaInicial"
              readonly
              matInput
              [matDatepicker]="picker"
              placeholder="FECHA INICIAL"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col s12 m6 l2">
          <mat-form-field>
            <input
              formControlName="fechaFinal"
              readonly
              matInput
              [matDatepicker]="picker1"
              placeholder="FECHA FINAL"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col s12 m6 l2">
          <button
            mat-raised-button
            color="accent"
            type="submit"
            [disabled]="!ventasGroup.valid || loading"
          >
            Consultar
          </button>
        </div>
      </div>
    </form>
  </div>
</mat-expansion-panel>

<br />
<mat-expansion-panel class="margen-expansion" expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6 class="titulo-solicitud">Resultados</h6>
    </mat-panel-title>
    <span class="menu-grafica">
      <button
        (click)="clickMenu($event)"
        matTooltip="OPCIONES DE VISUALIZACIÓN"
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Example icon-button with a menu"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button (click)="mostrarTabla()" mat-menu-item>
          <mat-icon>table_chart</mat-icon>
          <span>Ver Tabla</span>
        </button>
        <button (click)="fnMostrarTimeLine()" mat-menu-item>
          <mat-icon>timeline</mat-icon>
          <span>Ver Línea de Tiempo</span>
        </button>
        <button (click)="mostrarGrafica()" mat-menu-item>
          <mat-icon>pie_chart</mat-icon>
          <span>Ver Gráficas</span>
        </button>
        <button (click)="mostrarResumen()" mat-menu-item>
          <mat-icon>list</mat-icon>
          <span>Ver Resumen</span>
        </button>
      </mat-menu>
    </span>
  </mat-expansion-panel-header>

  <div
    [hidden]="
      mostrarTimeLine == 1 || mostrarTimeLine == 3 || mostrarTimeLine == 4
    "
    class="graficas"
  >
    <div class="row">
      <div class="col s12 m12 l6">
        <br />
        <div [hidden]="!loading">
          <mat-card class="example-card">
            <mat-card-content fxLayoutAlign="center">
              <mat-spinner></mat-spinner>
            </mat-card-content>
          </mat-card>
        </div>
        <div [hidden]="loading">
          <mat-card class="example-card">
            <mat-card-header>
              <div mat-card-avatar class="example-header-image"></div>
              <mat-card-title>Recorrido Vendedor Pastel</mat-card-title>
            </mat-card-header>
            <!--<ngx-chartjs [data]="datapieCategoria"  type="pie"></ngx-chartjs>-->
            <canvas id="recorridoPie"></canvas>
          </mat-card>
        </div>
        <!-- <app-contentbox show="true" titulo="Ultimas Atenciones" componente="1"></app-contentbox>-->
      </div>
      <div class="col s12 m12 l6">
        <br />
        <div [hidden]="!loading">
          <mat-card class="example-card">
            <mat-card-content fxLayoutAlign="center">
              <mat-spinner></mat-spinner>
            </mat-card-content>
          </mat-card>
        </div>
        <div [hidden]="loading">
          <mat-card class="example-card">
            <mat-card-header>
              <div mat-card-avatar class="example-header-image"></div>
              <mat-card-title>Recorrido Vendedor Barras</mat-card-title>
            </mat-card-header>
            <!--<ngx-chartjs [data]="datapieCategoria"  type="pie"></ngx-chartjs>-->
            <canvas id="recorridoBar"></canvas>
          </mat-card>
        </div>
        <!-- <app-contentbox show="true" titulo="Ultimas Atenciones" componente="1"></app-contentbox>-->
      </div>
    </div>
  </div>

  <div
    [hidden]="
      mostrarTimeLine == 2 || mostrarTimeLine == 3 || mostrarTimeLine == 4
    "
    class="time-line"
  >
    <div class="row">
      <div class="col s12 m12 l12">
        <form [formGroup]="searchForm">
          <mat-form-field>
            <input formControlName="searchText" matInput placeholder="BUSCAR" />
            <mat-icon matSuffix>search</mat-icon>
            <mat-hint>NUMERO DOCUMENTO / USUARIO / NIT / TIPO NOVEDAD</mat-hint>
          </mat-form-field>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col s12 m2 l2"></div>
      <div class="col s12 m8 l8" *ngIf="loading" style="text-align: center">
        <mat-spinner
          [diameter]="100"
          style="margin: 0 auto; top: 15px"
        ></mat-spinner>
      </div>
      <div
        class="col s12 m8 l8"
        *ngIf="!loading && dataRecorrido.length == 0"
        style="text-align: center"
      >
        <br />
        <mat-card>
          <h5 style="color: grey; font-weight: bold">
            No hay información para mostrar
          </h5>
        </mat-card>
      </div>
      <div class="col s12 m8 l8" *ngIf="!loading && dataRecorrido.length > 0">
        <div class="row">
          <div class="col s12 m12 l12" style="text-align: right">
            <button
              mat-icon-button
              matTooltip="EXPORTAR A EXCEL"
              (click)="exportarExcel()"
              matTooltipPosition="above"
            >
              <mat-icon svgIcon="excel"></mat-icon>
            </button>
          </div>
        </div>
        <mgl-timeline [alternate]="alternate" side="right">
          <mgl-timeline-entry
            *ngFor="
              let item of dataRecorrido
                | filter: searchForm.get('searchText').value;
              let i = index
            "
            id="{{ i }}"
          >
            <mgl-timeline-entry-header
              (click)="onHeaderClick($event, i)"
              style="cursor: pointer; text-align: center"
            >
              <div style="background-color: gray; margin-left: 10px">
                <span style="font-weight: bold; color: #ffffff">Novedad: </span
                ><span style="color: #ffffff">{{ item.tipoNovedad }}</span>
              </div>
            </mgl-timeline-entry-header>
            <mgl-timeline-entry-content>
              <div class="row">
                <div class="col s12 m12 l12" style="text-align: left">
                  <span style="font-weight: bold">Valor Transacción:</span>
                  {{ item.precio | currency: "$":"symbol":"1.0-0" }}
                </div>
              </div>
              <div class="row">
                <div class="col s12 m12 l12" style="text-align: left">
                  <span style="font-weight: bold">Usuario:</span>
                  {{ item.Usuario }}
                </div>
              </div>
              <div class="row">
                <div class="col s12 m12 l12" style="text-align: left">
                  <span style="font-weight: bold">Vendedor:</span>
                  {{ item.nombreVendedor }}
                </div>
              </div>
              <div class="row">
                <div class="col s12 m12 l12" style="text-align: left">
                  <span style="font-weight: bold">NIT:</span>
                  {{ item.NroDocId }}
                </div>
              </div>
              <div class="row">
                <div class="col s12 m12 l12" style="text-align: left">
                  <span style="font-weight: bold">Razón Social:</span>
                  {{ item.nombre }}
                </div>
              </div>
              <div class="row">
                <div class="col s12 m12 l12" style="text-align: left">
                  <span style="font-weight: bold">Dirección:</span>
                  {{ item.direccion }}
                </div>
              </div>
              <div class="row">
                <div class="col s12 m6 l6" style="text-align: left">
                  <span style="font-weight: bold">Telefono:</span>
                  {{ item.telefono }}
                </div>
                <div class="col s12 m6 l6" style="text-align: left">
                  <span style="font-weight: bold">Agencia:</span>
                  {{ item.agencia }}
                </div>
              </div>
              <div class="row">
                <div class="col s12 m12 l12" style="text-align: left">
                  <span style="font-weight: bold">Observaciones:</span>
                  {{ item.observaciones }}
                </div>
              </div>
            </mgl-timeline-entry-content>
            <mgl-timeline-entry-dot
              (click)="onDotClick($event, i)"
              [style.background-color]="
                item.idTpoVentaNovedad == 1
                  ? '#008000'
                  : item.idTpoVentaNovedad != 1
                  ? '#ff0000'
                  : null
              "
              class="click"
            >
            </mgl-timeline-entry-dot>
            <mgl-timeline-entry-side>
              <span>{{
                item.fechaVentaNovedad | date: "yyyy-MM-dd hh:mm:ss a"
              }}</span>
              <br />
              <span style="color: #a0a0a0">{{ item.documento }}</span>
            </mgl-timeline-entry-side>
          </mgl-timeline-entry>
        </mgl-timeline>
      </div>
      <div class="col s12 m2 l2"></div>
    </div>
  </div>

  <div
    [hidden]="
      mostrarTimeLine == 1 || mostrarTimeLine == 2 || mostrarTimeLine == 4
    "
    class="resumen"
  >
    <div class="row">
      <div class="col s12 m4 l4"></div>
      <div class="col s12 m4 l4" style="text-align: center" [hidden]="!loading">
        <mat-spinner
          [diameter]="100"
          style="margin: 0 auto; top: 15px"
        ></mat-spinner>
      </div>
      <div class="col s12 m4 l4" [hidden]="loading">
        <table
          datatable
          [dtOptions]="dtOptions"
          [dtTrigger]="dtTrigger['uno']"
          class="display"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th>Descripción</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of novedades; let i = index">
              <td [matTooltip]="item" matTooltipPosition="left">
                {{ item | slice: 0:20 }}
              </td>
              <td>{{ valoresResumen[i] }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td style="color: #107c41; font-weight: bold">
                TOTAL NOVEDADES :
              </td>
              <td>
                {{ totalNovedades }}
              </td>
            </tr>
            <tr>
              <td>
                <span style="color: #107c41; font-weight: bold">
                  TOTAL MONTO PEDIDOS :
                </span>
              </td>
              <td>{{ totalVenta | currency: "$":"symbol":"1.0-0" }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="col s12 m4 l4"></div>
    </div>
  </div>

  <div
    [hidden]="
      mostrarTimeLine == 1 || mostrarTimeLine == 2 || mostrarTimeLine == 3
    "
    class="tabla"
  >
    <div class="row">
      <div
        class="col s12 m12 l12"
        style="text-align: center"
        [hidden]="!loading"
      >
        <mat-spinner
          [diameter]="100"
          style="margin: 0 auto; top: 15px"
        ></mat-spinner>
      </div>
      <div class="col s12 m12 l12" [hidden]="loading">
        <table
          [hidden]="!haveData"
          datatable
          [dtOptions]="dtOptions"
          [dtTrigger]="dtTrigger['dos']"
          class="display"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th>Item</th>
              <th>Documento</th>
              <th>Fecha</th>
              <th>Novedad</th>
              <th>Usuario</th>
              <th>Nombre Usuario</th>
              <th>NIT</th>
              <th>Razón Social</th>
              <th>Direccion</th>
              <th>Telefono</th>
              <th>Agencia</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of dataRecorrido">
              <td style="text-align: center">
                <mat-icon
                  *ngIf="item.idTpoVentaNovedad == 1"
                  style="color: green; cursor: pointer"
                  [matTooltip]="item.tipoNovedad"
                  matTooltipPosition="above"
                  >check_circle
                </mat-icon>
                <mat-icon
                  *ngIf="item.idTpoVentaNovedad != 1"
                  style="color: orangered; cursor: pointer"
                  [matTooltip]="item.tipoNovedad"
                  matTooltipPosition="above"
                  >error
                </mat-icon>
              </td>
              <td>{{ item.documento }}</td>
              <td>
                {{ item.fechaVentaNovedad | date: "yyyy-MM-dd hh:mm:ss a" }}
              </td>
              <td>{{ item.tipoNovedad }}</td>
              <td>{{ item.Usuario }}</td>
              <td>{{ item.nombreVendedor }}</td>
              <td>{{ item.NroDocId }}</td>
              <td>{{ item.nombre }}</td>
              <td>{{ item.direccion }}</td>
              <td>{{ item.telefono }}</td>
              <td>{{ item.agencia }}</td>
              <td>{{ item.precio | currency: "$":"symbol":"1.0-0" }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="2">
                <span style="color: #107c41; font-weight: bold">
                  TOTAL MONTO PEDIDOS :
                </span>
              </th>
              <th colspan="2">
                {{ totalVenta | currency: "$":"symbol":"1.0-0" }}
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</mat-expansion-panel>
